import { auditSupport } from '@mi-front/api-clients';
import { ValidateAndUploadFileView } from '../ValidateAndUploadFileView';
import { LtxPreview } from './LtxPreview';
import { Station } from '@app/core/types/stations';

export function LtxUpload({ station }: { station: Station }) {
  return (
    <ValidateAndUploadFileView<
      auditSupport.MinUploadLtxResultDto,
      { data: auditSupport.BulkUploadLtxFilesMutationRequest }
    >
      station={station}
      accept=".ltx,.LTX,.ltx.txt,.LTX.TXT,text/plain"
      fileType="LTX"
      useUploadMutation={auditSupport.useBulkUploadLtxFiles}
      renderPreview={(data) => <LtxPreview entries={data.entries ?? []} />}
    />
  );
}
